var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"end-run"},[(_vm.isDisplayMessage)?_c('div',{staticClass:"message flex-centerize"},[_c('div',{staticClass:"done-text"},[_vm._v(_vm._s(_vm.message || _vm.messageDefault))]),_c('SIcon',{attrs:{"name":"succ-sign"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }